// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));

export default function customerWalletsTableData(wallets) {
  return {
    columns: [
      { Header: "رقم المحفظة", accessor: "id", align: "center" },
      { Header: "اسم صاحب المحفظة", accessor: "userName", align: "center" },
      { Header: "نوع صاحب المحفظة", accessor: "userType", align: "center" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "العملة", accessor: "currency", align: "center" },
      { Header: "الرصيد", accessor: "balance", align: "center" },
      { Header: "تاريخ الإنشاء", accessor: "createdAt", align: "center" },
      { Header: "عمليات المحفظة", accessor: "actions", align: "center" },
    ],
    rows: wallets.map((wallet) => {
      // زر العمليات مع التوجيه
      const ActionsButton = () => {
        const navigate = useNavigate();
        return (
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<MonetizationOnIcon />}
            onClick={() => navigate(`/customer_wallets/${wallet.id}`)}
          >
            عمليات المحفظة
          </Button>
        );
      };
      return {
        id: wallet.id,
        userName: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {wallet.user?.name || "-"}
          </MDTypography>
        ),
        userType: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {wallet.user?.type || "-"}
          </MDTypography>
        ),
        status: (
          <MDTypography
            variant="caption"
            color={wallet.status === "active" ? "success" : "error"}
            fontWeight="medium"
          >
            {wallet.status === "active" ? "نشطة" : "غير نشطة"}
          </MDTypography>
        ),
        currency: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {wallet.currency?.name || "-"}
          </MDTypography>
        ),
        balance: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {wallet.balance}
          </MDTypography>
        ),
        createdAt: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {wallet.created_at ? wallet.created_at.split("T")[0] : "-"}
          </MDTypography>
        ),
        actions: <ActionsButton />,
      };
    }),
  };
}
